package com.anjuros.website.templates.template9.modules

import com.anjuros.website.templates.template9.util.ResKey
import com.anjuros.website.templates.template9.util.Template9Res

enum class Template9Service(
    val icon: String,
    val image: String,
    val title: ResKey,
    val description: ResKey,
    val accentIcon: Boolean,
    val price: String,
    val priceUnit: ResKey
) {
    SoloWalks(
        icon = Template9Res.Icon.paw_white,
        image = Template9Res.Image.service_solo,
        title = ResKey.TEMPLATE9_SERVICE1_TITLE,
        description = ResKey.TEMPLATE9_SERVICE1_DESC,
        accentIcon = false,
        price = "15",
        priceUnit = ResKey.TEMPLATE9_PER_WALK
    ),
    GroupWalks(
        icon = Template9Res.Icon.group_white,
        image = Template9Res.Image.service_group,
        title = ResKey.TEMPLATE9_SERVICE2_TITLE,
        description = ResKey.TEMPLATE9_SERVICE2_DESC,
        accentIcon = true,
        price = "12",
        priceUnit = ResKey.TEMPLATE9_PER_WALK
    ),
    HomeVisits(
        icon = Template9Res.Icon.home_white,
        image = Template9Res.Image.service_home,
        title = ResKey.TEMPLATE9_SERVICE3_TITLE,
        description = ResKey.TEMPLATE9_SERVICE3_DESC,
        accentIcon = false,
        price = "10",
        priceUnit = ResKey.TEMPLATE9_PER_VISIT
    ),
    OvernightCare(
        icon = Template9Res.Icon.moon_white,
        image = Template9Res.Image.service_overnight,
        title = ResKey.TEMPLATE9_SERVICE4_TITLE,
        description = ResKey.TEMPLATE9_SERVICE4_DESC,
        accentIcon = true,
        price = "45",
        priceUnit = ResKey.TEMPLATE9_PER_NIGHT
    )
}
